import type { ReactNode } from "react";

/**
 * Something the console has to keep saying, drawn beside the screen rather than
 * inside the sidebar. Ours: the fleet says this kind of thing with `sonner`
 * (a toast), which this console does not have.
 *
 * A refused sign-out went in the sidebar's footer first, which is right on a
 * desktop and wrong on a phone: there the sidebar is a sheet, so the sentence
 * appears over the screen and is gone the moment the sheet is closed — and what
 * it is about is a session that is still open. It survives here because this is
 * the frame, not the drawer (found in review of #10).
 */
export function LayoutNotice({ children }: { children: ReactNode }) {
  return (
    <p
      role="status"
      className="border-b border-border bg-secondary px-4 py-2 text-sm text-secondary-foreground"
    >
      {children}
    </p>
  );
}
